module.exports = __webpack_public_path__ + "static/media/WebPay.8ea2212e.png";